import { render } from "./project-module-add.vue?vue&type=template&id=3233e878&scoped=true"
import script from "./project-module-add.vue?vue&type=script&lang=js"
export * from "./project-module-add.vue?vue&type=script&lang=js"

import "./project-module-add.vue?vue&type=style&index=0&id=3233e878&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3233e878"]])

export default __exports__